import {apiFetch} from "../../../api/apiFetch";
import {
  API_PATH_ApiCreateCompanyPost,
  IApiCreateCompanyPostBodyRequest,
  IApiCreateCompanyPostResponse,
} from "mhc-server/dist/interfaces";

export const apiCreateCompanyPost = (data: IApiCreateCompanyPostBodyRequest): Promise<IApiCreateCompanyPostResponse> => {
  return apiFetch.request<null, IApiCreateCompanyPostBodyRequest, IApiCreateCompanyPostResponse>({
    path: API_PATH_ApiCreateCompanyPost,
    method: 'POST',
    body: data,
  });
};
